import { Building2, Gem, House as Home, Briefcase, HardHat, Car, Coins, Shield, PackageOpen, Dice5, Scale, HandHeart, ClipboardList, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
const giros = [{
  icon: Building2,
  name: "Notarías"
}, {
  icon: Gem,
  name: "Joyerías"
}, {
  icon: Home,
  name: "Inmobiliarias"
}, {
  icon: Briefcase,
  name: "Brokers y SOFOM"
}, {
  icon: HardHat,
  name: "Desarrolladoras"
}, {
  icon: Car,
  name: "Compraventa de vehículos"
}, {
  icon: Coins,
  name: "Activos virtuales"
}, {
  icon: Shield,
  name: "Blindadoras"
}, {
  icon: PackageOpen,
  name: "Comercio exterior"
}, {
  icon: Dice5,
  name: "Juegos y sorteos"
}, {
  icon: Scale,
  name: "Mediadores y árbitros"
}, {
  icon: HandHeart,
  name: "Donativos"
}, {
  icon: ClipboardList,
  name: "Servicios profesionales"
}];
export default function BarridoDeGiros() {
  return <section data-section-id="REEMPLAZAR" id="barrido-de-giros" className="bg-background text-foreground py-10 md:py-14 border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6">
        <p className="text-center text-xs font-mono uppercase tracking-widest text-muted-foreground mb-6">
          Diseñado para los 17 sujetos obligados del Art. 17 LFPIORPI
        </p>
        <div className="relative">
          <div className="flex gap-3 overflow-x-auto pb-3 scrollbar-hide snap-x snap-mandatory md:flex-wrap md:justify-center md:overflow-visible">
            {giros.map((giro, i) => {
            const Icon = giro.icon;
            return <div key={giro.name} data-index={i} className="snap-start flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-card border border-border hover:border-primary/40 transition-colors">
                  <Icon className="size-4 text-primary" strokeWidth={1.5} />
                  <span className="font-default text-sm text-slate-300 whitespace-nowrap">
                    {giro.name}
                  </span>
                </div>;
          })}
          </div>
        </div>
        <div className="mt-6 text-center">
          <Link to="#">
            <span className="inline-flex items-center gap-2 text-sm font-mono uppercase tracking-widest text-primary hover:underline">
              Ver cómo Notalia atiende cada giro
              <ArrowRight className="size-4" />
            </span>
          </Link>
        </div>
      </div>
    </section>;
}